import { createAction } from "@reduxjs/toolkit";

import type { ApplicationScope } from "@superblocksteam/shared";

import { ItemKinds } from "legacy/pages/Editor/PropertyPane/ItemKindConstants";

import { showItemPropertyPane } from "../../../../legacy/actions/propertyPaneActions";

export interface RenameCustomEventUpdate {
  eventId: string;
  propertyName: string;
  propertyValue: unknown;
  scope: ApplicationScope;
}

export const renameCustomEvents = createAction(
  "RENAME_CUSTOM_EVENTS",
  (updates: RenameCustomEventUpdate[]) => ({
    payload: { updates },
  }),
);

export const duplicateCustomEvent = createAction(
  "DUPLICATE_CUSTOM_EVENT",
  (payload: {
    eventId: string;
    fromScope: ApplicationScope;
    toScope: ApplicationScope;
  }) => ({
    payload,
  }),
);

export const setCreatingCustomEvent = createAction(
  "SET_CREATING_CUSTOM_EVENT",
  (payload: boolean) => ({ payload }),
);

export const editEventPropertyPane = (
  eventId: string,
  scope: ApplicationScope,
) => showItemPropertyPane({ kind: ItemKinds.CUSTOM_EVENT, id: eventId, scope });
